<script setup lang="ts">
const { color = '#F8652F' } = defineProps<{ color?: string }>();
</script>

<template>
  <svg viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.89707 5.25L-3.95954e-05 2.72281e-07L7.79419 9.53674e-07L3.89707 5.25Z"
      :fill="color"
    />
  </svg>
</template>
